import { render } from "./MethodAssessmentSchemaPage.vue?vue&type=template&id=4e2e4f0f"
import script from "./MethodAssessmentSchemaPage.vue?vue&type=script&lang=js"
export * from "./MethodAssessmentSchemaPage.vue?vue&type=script&lang=js"

import "./MethodAssessmentSchemaPage.vue?vue&type=style&index=0&id=4e2e4f0f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__